import React, { CSSProperties } from 'react';
import { Transition } from 'react-transition-group';

export interface Props {
  isVisible?: boolean;
  maxHeight?: string;
  duration?: number;
  onEntered?(): void;
  onExited?(): void;
  wrapperStyleOverride?: CSSProperties;
}

const TransitionSlider: React.FC<Props> = ({
  duration = 300,
  maxHeight = '200px',
  isVisible: isVisibleProp,
  onEntered,
  onExited,
  children,
  wrapperStyleOverride,
}) => {
  const defaultStyle = {
    transition: `max-height ${duration}ms ease-in`,
    maxHeight: 0,
    overflow: 'hidden',
  };

  const transitionStyles = {
    entering: { maxHeight: maxHeight, overflow: 'hidden' },
    entered: {
      maxHeight: maxHeight,
      overflow: 'auto',
      ...wrapperStyleOverride,
    },
  };

  const isVisible = isVisibleProp !== undefined ? isVisibleProp : !!children;

  return (
    <Transition in={isVisible} timeout={duration} onEntered={onEntered} onExited={onExited}>
      {(state) => (
        <div className="transition-wrapper" style={{ ...defaultStyle, ...transitionStyles[state] }}>
          {children}
        </div>
      )}
    </Transition>
  );
};

export default TransitionSlider;
